'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPhotoswipe = require('react-photoswipe');

var _antd = require('antd');

require('react-photoswipe/lib/photoswipe.css');

require('antd/dist/antd.css');

require('../assets/carousel.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselWrapper = function (_Component) {
  (0, _inherits3.default)(CarouselWrapper, _Component);

  function CarouselWrapper(props) {
    (0, _classCallCheck3.default)(this, CarouselWrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CarouselWrapper.__proto__ || (0, _getPrototypeOf2.default)(CarouselWrapper)).call(this, props));

    _this.handleClose = function () {
      _this.setState({ isOpen: false });
    };

    _this.getThumbnailContent = function (item) {
      return _react2.default.createElement('img', { src: item.src });
    };

    _this.carouselChildren = (0, _map3.default)(_this.props.images, function (image, index) {
      return _react2.default.createElement('img', { className: 'default-carousel-img', src: image.src, key: index });
    });

    _this.handleOpen = function () {
      _this.setState({ isOpen: true });
    };

    _this.state = { isOpen: false };
    return _this;
  }

  (0, _createClass3.default)(CarouselWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ isOpen: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var popupComponent = this.props.enableZoom ? _react2.default.createElement(_reactPhotoswipe.PhotoSwipe, { isOpen: this.state.isOpen, items: this.props.images, options: this.props.popupOptions }) : null;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { onDoubleClick: this.props.enableZoom ? this.handleOpen : null },
          _react2.default.createElement(
            _antd.Carousel,
            this.props.carouselOptions,
            this.carouselChildren
          )
        ),
        popupComponent
      );
    }
  }]);
  return CarouselWrapper;
}(_react.Component);

;

CarouselWrapper.propTypes = {
  carouselOptions: _propTypes2.default.object,
  images: _propTypes2.default.array,
  popupOptions: _propTypes2.default.object
};

exports.default = CarouselWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/rcw-carousel/lib/container/carousel.js
// module id = 2269
// module chunks = 0